import React from "react";
import moment from "moment-timezone";
import get from "lodash/get";
import {
  FlatButton,
  RaisedButton,
  TextField,
  Checkbox,
  Styles
} from "material-ui";
import { Navigation } from "react-router";
import { colors } from "material-ui/styles";

import UserStore from "../../stores/UserStore";

import { formatPrice } from "../../util";
import update from "immutability-helper";
import Label from "./label.jsx";
import SelectField from "./select-field.jsx";
import Select from "react-select";
import CurrencyField from "./currency-field.jsx";
import QuantityEditor from "./quantity-editor.jsx";
import EventBucketStore from "../../stores/EventBucketStore";
import InjectedSelect from "./injected-select.jsx";
import DateTimeField from "./datetime-field.jsx";

import config from "../../config";

class TicketBucketEditor extends React.Component {
  constructor(props) {
    super(props);
    const { bucket } = this.props;
    this.state = {
      dirty: false,
      showRushLinePriceEditor: false,
      showApplicablePassBucketsEditor:
        bucket && bucket.applicable_pass_buckets.length,
      showMaxQuantityEditor: false,
      showCompanionEditor: false
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.save = this.save.bind(this);
    this.delete = this.delete.bind(this);
  }

  getStyles() {
    return {
      stats: {
        marginBottom: 10,
        fontSize: "1.2em",
        fontStyle: "italic"
      },
      editor: {
        position: "relative",
        border: "1px solid #ccc",
        padding: 20,
        margin: "20px 0"
      },
      outer: {
        marginTop: 10
      },
      inner: {
        width: "50%",
        maxWidth: 370,
        display: "inline-block",
        verticalAlign: "top"
      },
      actions: {
        marginTop: 20
      }
    };
  }

  onChange(id, e) {
    this.onChangeValue(id, e.target.value);
  }

  onChangeValue(id, value) {
    const bucket = update(
      this.props.bucket,
      typeof id === "object" ? id : { [id]: { $set: value } }
    );
    this.props.onEdit(bucket);
  }

  save() {
    // this.props.onEdit(this.props.index, this.props.bucket);
    // this.setState({ isSaving: true });
  }

  delete() {
    if (
      window.confirm(
        "Are you sure? This will also delete all tickets in this bucket, which will make them unusable."
      )
    ) {
      this.props.delete();
    }
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var bucket = newProps.bucket;

    // Don't overwrite unless we're actively saving
    if (this.state.bucket && this.state.dirty && !this.state.isSaving) {
      return;
    }

    this.setState({ bucket, dirty: false });
  }

  render() {
    var styles = this.getStyles();

    const showCurrencyEditor =
      [
        "629e694dd48797006a9d2cdc", // banff
        "6238cc51b3e10b005cbe04b2", // banff demo
        "5ec53f5d15980b0071513706", // adff
        "626910803d077e0030526b0c", // film & campaign ltd
        "62fa9168ef65d80029436fce", // endowhat
        "5ef11dd7c0de2d00a17fee9b", // coup 53 uk
        "5f5aa260ada3ad00450caa7e", // education without borders
        "5c47cc414a8fe0001d4bb705", // together filmes
        "687504d248f9660a2ba7da6d", // tragic awakening film
        "687a9cbd11060ebee7c7ee2b"  // narrative entertainmment (NGN)
      ].includes((UserStore.getUser() || {}).id) || UserStore.isGod();
    const userCurrency = (UserStore.getUser() || { currency: "usd" }).currency;
    const hasMultiCurrency = this.props.bucket.variants.some(v => {
      return v.currency && v.currency !== userCurrency;
    });

    const contingentTicketBucketsEnabled =
      [
        "632796a787711400538e66da", // sundance
        "5dae0d7c41443700308287c5" // sundance sandbox
      ].includes((UserStore.getUser() || {}).id) || UserStore.isGod();

    const roleList = UserStore.getState().roles || [];
    const roles = [];
    for (const roleId in roleList) {
      if (roleId === "admin") continue;

      roles.push({
        value: roleId,
        label: roleList[roleId].label
      });
    }

    return (
      <div style={styles.editor}>
        <div>
          <div
            style={{
              position: "absolute",
              right: 10,
              top: 10,
              lineHeight: "1.1em",
              fontSize: "0.75em",
              textAlign: "right",
              color: "rgba(0,0,0,0.5)"
            }}
          >
            ID: {get(this.props, "bucket.id", "Not yet assigned")}
            {get(this.props, "bucket.id") ? (
              <div>
                <strong style={{ fontVariant: "tabular-nums" }}>
                  {get(this.props, "bucket.quantity_sold", 0)}
                </strong>{" "}
                sold /{" "}
                <strong style={{ fontVariant: "tabular-nums" }}>
                  {get(this.props, "bucket.quantity_remaining") >=
                  Number.MAX_SAFE_INTEGER
                    ? "∞"
                    : Math.max(
                        get(this.props, "bucket.quantity_remaining", 0),
                        0
                      )}
                </strong>{" "}
                remaining
              </div>
            ) : null}
          </div>

          {hasMultiCurrency ? (
            <div
              style={{
                marginTop: 15,
                marginBottom: 5,
                border: `1px solid ${colors.blue900}`,
                padding: "4px 10px",
                color: colors.blue900,
                backgroundColor: colors.blue50,
                borderRadius: 10
              }}
            >
              <strong>Multi-currency ticket bucket</strong>: This ticket bucket
              is priced in multiple currencies. Users will be recommended prices
              in their local currency, if available. They can also select
              another currency. Payments will be instantly converted to your
              default currency ({userCurrency.toUpperCase()}) at the time of
              sale using Stripe's current mid-market exchange rate.
            </div>
          ) : null}

          <TextField
            value={get(this.props, "bucket.name", "")}
            floatingLabelText="Name"
            floatingLabelFixed={true}
            onChange={e => this.onChangeValue("name", e.target.value)}
          />
          <CurrencyField
            value={get(this.state, "bucket.price", "")}
            floatingLabelText={
              this.props.bucket.variable_price ? "Default price" : "Price"
            }
            floatingLabelFixed={true}
            placeholder="$0.00"
            onChange={e => this.onChangeValue("price", e.target.value)}
            style={{ marginLeft: 7, width: 150 }}
          />
          {this.props.venueDetails &&
          this.props.venueDetails.use_reserved_seating ? (
            <SelectField
              value={this.props.bucket.reserved_seating_category}
              options={this.props.venueDetails.seatmap_categories.map(c => {
                return {
                  category: c,
                  value: c.key,
                  label: (
                    <span>
                      <span
                        style={{
                          display: "inline-block",
                          height: "1em",
                          width: "1em",
                          verticalAlign: -2,
                          backgroundColor: c.color
                        }}
                      />{" "}
                      {c.label}
                    </span>
                  )
                };
              })}
              clearable={false}
              label="Seatmap category"
              placeholder="Select category"
              style={{
                display: "inline-block",
                verticalAlign: 27,
                marginLeft: 15,
                width: 200
              }}
              labelStyle={{ marginBottom: 0 }}
              onChange={s => {
                if (s && s.value) {
                  this.onChangeValue({
                    reserved_seating_category: { $set: s.value },
                    name:
                      !this.state.dirty || !this.props.bucket.name
                        ? { $set: s.category.label }
                        : undefined
                  });
                }
              }}
            />
          ) : (
            <TextField
              value={get(this.state, "bucket.quantity", "")}
              floatingLabelText="Quantity"
              floatingLabelFixed={true}
              placeholder="Unlimited"
              onChange={e => {
                if (e.target.value) {
                  this.onChangeValue({
                    unlimited: { $set: false },
                    quantity: { $set: parseInt(e.target.value, 10) }
                  });
                } else {
                  this.onChangeValue({
                    unlimited: { $set: true },
                    quantity: { $set: "" }
                  });
                }
              }}
              style={{ marginLeft: 7, width: 70 }}
            />
          )}
        </div>

        <div style={styles.outer}>
          <div style={styles.inner}>
            <div>
              <Checkbox
                label="Public for online customer orders"
                checked={this.props.bucket.public}
                onCheck={e =>
                  this.onChangeValue("public", !this.props.bucket.public)
                }
              />
            </div>
            {this.props.hasMultipleTicketBuckets ||
            (this.props.bucket.applicable_pass_buckets &&
              this.props.bucket.applicable_pass_buckets.length) ? (
              <div>
                <Checkbox
                  label="Restrict ordering to certain pass buckets only"
                  checked={this.state.showApplicablePassBucketsEditor}
                  onCheck={e =>
                    this.setState(
                      {
                        showApplicablePassBucketsEditor:
                          !this.state.showApplicablePassBucketsEditor
                      },
                      () => {
                        this.onChangeValue("applicable_pass_buckets", []);
                      }
                    )
                  }
                />
                {this.state.showApplicablePassBucketsEditor ? (
                  <InjectedSelect
                    style={{ margin: "-0.5em 3em 1em" }}
                    value={this.props.bucket.applicable_pass_buckets}
                    types={["all_pass_buckets"]}
                    multi={true}
                    label="Allowed pass buckets"
                    labelFormatter={b =>
                      `${b.name}${
                        b.event_bucket !== this.props.bucket.event_bucket &&
                        EventBucketStore.getEventBucketById(b.event_bucket)
                          ? ` (${
                              EventBucketStore.getEventBucketById(
                                b.event_bucket
                              ).name
                            })`
                          : ""
                      }`
                    }
                    eventBucketId={this.props.bucket.event_bucket}
                    onChange={selected =>
                      this.onChangeValue("applicable_pass_buckets", selected)
                    }
                    filterBy={function (o) {
                      // if pass bucket is in this event bucket, it is allowed
                      if (o.event_bucket === this.props.bucket.event_bucket) {
                        return true;
                      }
                      // if pass bucket is not in this event bucket but
                      // applies globally, it is allowed
                      for (let y = 0; y < o.rules.length; y++) {
                        //"global_target.event_bucket.id": eventBucket
                        if (o.rules[y].global_target === "*") {
                          return true;
                        } else if (
                          o.rules[y].global_target &&
                          o.rules[y].global_target.event_bucket
                        ) {
                          let idRule = o.rules[y].global_target.event_bucket.id;
                          if (idRule === this.props.bucket.event_bucket) {
                            return true;
                          } else if (
                            Array.isArray(idRule) &&
                            idRule.indexOf(this.props.bucket.event_bucket) !==
                              -1
                          ) {
                            return true;
                          }
                        }
                      }
                      return false;
                    }.bind(this)}
                  />
                ) : null}
              </div>
            ) : null}
            {!contingentTicketBucketsEnabled ? null : this.props.bucket
                .contingent_has_rolled_over ? (
              <div>
                <Checkbox
                  label={`Capacity rollover completed: ${
                    this.props.bucket.contingent_rollover_status_message ||
                    "unknown status"
                  } (${moment(this.props.bucket.contingent_rollover_date)
                    .tz(this.props.eventDetails.timezone)
                    .format("lll z")})`}
                  checked
                  disabled
                />
              </div>
            ) : this.props.hasMultipleTicketBuckets ? (
              <div>
                <Checkbox
                  label={
                    <span>
                      <i>Advanced</i>: "Roll over" unused capacity to another
                      ticket bucket at a certain date & time
                    </span>
                  }
                  checked={this.props.bucket.contingent}
                  onCheck={e =>
                    this.onChangeValue(
                      "contingent",
                      !this.props.bucket.contingent
                    )
                  }
                />
                {this.props.bucket.contingent ? (
                  <div style={{ margin: "-0.5em 3em 0.5em" }}>
                    <div>
                      <SelectField
                        value={
                          this.props.bucket.contingent_rollover_ticket_bucket
                        }
                        options={this.props.ticketBuckets
                          .filter(b => b.id !== this.props.bucket.id)
                          .map(b => {
                            return {
                              value: b.id,
                              label: b.name
                            };
                          })}
                        clearable={false}
                        label="Target ticket bucket"
                        placeholder="Ticket bucket"
                        style={{
                          display: "inline-block",
                          width: 200
                        }}
                        onChange={s => {
                          if (s && s.value) {
                            this.onChangeValue(
                              "contingent_rollover_ticket_bucket",
                              s.value
                            );
                          }
                        }}
                      />
                      <DateTimeField
                        value={this.props.bucket.contingent_rollover_date}
                        label={"Rollover date"}
                        unclearable={true}
                        timezone={this.props.eventDetails.timezone}
                        onChange={(e, v) =>
                          this.onChangeValue("contingent_rollover_date", v)
                        }
                        style={{ display: "inline-block" }}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}
            {!this.props.bucket.public ? (
              <div>
                <Checkbox
                  label="Exclude quantity from total event capacity"
                  checked={this.props.bucket.exclude_capacity}
                  onCheck={e =>
                    this.onChangeValue(
                      "exclude_capacity",
                      !this.props.bucket.exclude_capacity
                    )
                  }
                />
              </div>
            ) : null}
            {this.props.bucket.exclude_capacity ? (
              <div>
                <Checkbox
                  label="Lock sales to administrators and selected roles"
                  checked={this.props.bucket.lock_admin_only}
                  onCheck={e =>
                    this.onChangeValue(
                      "lock_admin_only",
                      !this.props.bucket.lock_admin_only
                    )
                  }
                />
              </div>
            ) : null}

            {this.props.bucket.lock_admin_only ? (
              <div>
                <Select
                  clearable={true}
                  multi={true}
                  value={this.props.bucket.lock_admin_only_role}
                  placeholder="Role allowed to view"
                  options={roles}
                  simpleValue={true}
                  onChange={v => {
                    this.onChangeValue("lock_admin_only_role", v);
                  }}
                />
              </div>
            ) : null}

            <div>
              <Checkbox
                label="Restrict maximum quantity of tickets per customer"
                checked={
                  this.props.bucket.max_quantity_per_person ||
                  this.state.showMaxQuantityEditor
                }
                onCheck={(e, checked) => {
                  this.setState({ showMaxQuantityEditor: checked }, () => {
                    this.onChangeValue(
                      "max_quantity_per_person",
                      checked ? 4 : null
                    );
                  });
                }}
              />
              {this.state.showMaxQuantityEditor ||
              this.props.bucket.max_quantity_per_person ? (
                <div style={{ margin: "-0.5em 3em 0.5em" }}>
                  <Label>Max quantity per customer</Label>
                  <QuantityEditor
                    style={{ marginTop: -14, marginLeft: -17 }}
                    quantity={this.props.bucket.max_quantity_per_person}
                    updateQuantity={q =>
                      this.setState({ showMaxQuantityEditor: true }, () =>
                        this.onChangeValue("max_quantity_per_person", q)
                      )
                    }
                  />
                </div>
              ) : null}
            </div>
            {this.props.eventDetails ? (
              <div>
                <Checkbox
                  style={{ display: "inline-block" }}
                  label={
                    this.props.eventDetails.is_virtual
                      ? "Enable pay-what-you-can virtual unlocks"
                      : "Enable pay-what-you-can ticket purchases"
                  }
                  checked={this.props.bucket.variable_price}
                  onCheck={(e, checked) => {
                    this.onChangeValue(
                      "variable_price",
                      !this.props.bucket.variable_price
                    );
                  }}
                />
                {this.props.bucket.variable_price ? (
                  <div style={{ margin: "-1em 3em 0.5em" }}>
                    <CurrencyField
                      value={this.props.bucket.variable_price_minimum}
                      floatingLabelText={
                        this.props.eventDetails.is_virtual
                          ? "Minimum price per unlock"
                          : "Minimum price per ticket"
                      }
                      floatingLabelFixed={true}
                      placeholder="$0.00"
                      onChange={e =>
                        this.onChangeValue(
                          "variable_price_minimum",
                          e.target.value
                        )
                      }
                      onBlur={e => {
                        // If the new minimum is greater than the default bucket price,
                        // bump up the bucket price to the new minimum price.
                        const min = e.target.value;
                        if (get(this.state, "bucket.price", 0) < min) {
                          this.onChangeValue("price", min);
                        }
                      }}
                      style={{ width: 300 }}
                    />
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>

          <div style={styles.inner}>
            <div>
              <Checkbox
                label="Sell additional variants of this ticket bucket"
                checked={this.props.bucket.variants.length > 0}
                onCheck={(e, checked) =>
                  this.onChangeValue("variants", checked ? [{}] : [])
                }
              />
            </div>

            {this.props.bucket.variants.length > 0 ? (
              <div style={{ margin: "-1.5em 0 1.5em" }}>
                <ul style={{ listStyle: "none" }}>
                  {this.props.bucket.variants.map((v, i) => {
                    const currency = v.currency;
                    return (
                      <li
                        style={{ marginBottom: "-0.5em", whiteSpace: "nowrap" }}
                      >
                        <TextField
                          name={`variantName-${i}`}
                          placeholder="Variant name"
                          value={v.name}
                          style={{ maxWidth: "50%" }}
                          onChange={e => {
                            this.props.bucket.variants[i].name = e.target.value;
                            this.onChangeValue(
                              "variants",
                              this.props.bucket.variants
                            );
                          }}
                        />
                        <CurrencyField
                          name={`variantPrice-${i}`}
                          placeholder="$0.00"
                          value={v.price}
                          currency={currency}
                          onChange={e => {
                            this.props.bucket.variants[i].price =
                              e.target.value;
                            this.onChangeValue(
                              "variants",
                              this.props.bucket.variants
                            );
                          }}
                          style={{ marginLeft: 7, width: 150, maxWidth: "25%" }}
                        />
                        {this.props.eventDetails.is_virtual &&
                        showCurrencyEditor ? (
                          <div
                            style={{
                              width: 70,
                              display: "inline-block",
                              verticalAlign: -12,
                              marginLeft: 7,
                              maxWidth: "20%"
                            }}
                          >
                            <Select
                              clearable={false}
                              value={
                                v.currency ||
                                (UserStore.getUser() || { currency: "usd" })
                                  .currency
                              }
                              options={config.fee.supported_currencies.map(
                                k => ({
                                  label: k.toUpperCase(),
                                  value: k
                                })
                              )}
                              onChange={v => {
                                const isUserCurrency =
                                  v.value ===
                                  (UserStore.getUser() || { currency: "usd" })
                                    .currency;

                                this.props.bucket.variants[i].currency =
                                  isUserCurrency ? undefined : v.value;
                                this.onChangeValue(
                                  "variants",
                                  this.props.bucket.variants
                                );
                              }}
                            />
                          </div>
                        ) : null}
                        <FlatButton
                          style={{ marginLeft: 7, minWidth: 30 }}
                          label="×"
                          onTouchTap={() => {
                            if (
                              window.confirm(
                                "Are you sure you want to delete this variant? This will also delete all tickets of this variant type."
                              )
                            ) {
                              const variants = [...this.props.bucket.variants];
                              variants.splice(i, 1);
                              this.onChangeValue("variants", variants);
                            }
                          }}
                        />
                      </li>
                    );
                  })}
                  <li style={{ marginTop: "1em" }}>
                    <RaisedButton
                      label="Add another variant"
                      onTouchTap={() =>
                        this.onChangeValue(
                          "variants",
                          this.props.bucket.variants.concat({})
                        )
                      }
                    />
                  </li>
                </ul>
              </div>
            ) : null}

            {!this.props.eventDetails.is_virtual ? (
              <div>
                <Checkbox
                  label={
                    <span>
                      Custom rush line ticket price (current:{" "}
                      <strong>
                        {formatPrice(
                          this.props.bucket.rush_line_price ||
                            (
                              EventBucketStore.getEventBucketById(
                                this.state.bucket &&
                                  this.state.bucket.event_bucket
                              ) || {}
                            ).rush_line_default_price ||
                            this.props.bucket.price
                        )}
                      </strong>
                      )
                    </span>
                  }
                  checked={
                    this.props.bucket.rush_line_price ||
                    this.state.showRushLinePriceEditor
                  }
                  onCheck={(e, checked) => {
                    this.setState({ showRushLinePriceEditor: checked }, () => {
                      !checked && this.onChangeValue("rush_line_price", null);
                    });
                  }}
                />
                {this.state.showRushLinePriceEditor ||
                this.props.bucket.rush_line_price ? (
                  <CurrencyField
                    floatingLabelText="Rush line ticket price"
                    floatingLabelFixed={true}
                    placeholder="$0.00"
                    style={{ margin: "-0.5em 2.5em 0.5em" }}
                    value={this.props.bucket.rush_line_price}
                    onChange={e =>
                      this.setState({ showRushLinePriceEditor: true }, () =>
                        this.onChangeValue("rush_line_price", e.target.value)
                      )
                    }
                  />
                ) : null}
              </div>
            ) : null}

            <div>
              <Checkbox
                style={{ display: "inline-block" }}
                label="Auto-issue companion ticket to another event"
                checked={
                  (this.props.bucket.autoissue_companion_ticket &&
                    this.props.bucket.autoissue_companion_ticket.length) ||
                  this.state.showCompanionEditor
                }
                onCheck={e =>
                  this.setState(
                    { showCompanionEditor: !this.state.showCompanionEditor },
                    () => {
                      this.onChangeValue("autoissue_companion_ticket", []);
                    }
                  )
                }
              />
              {this.state.showCompanionEditor ||
              (this.props.bucket.autoissue_companion_ticket &&
                this.props.bucket.autoissue_companion_ticket.length) ? (
                <InjectedSelect
                  multi={true}
                  style={{ margin: "-0.5em 3em 1em" }}
                  value={this.props.bucket.autoissue_companion_ticket}
                  types={["ticket_buckets"]}
                  label="Companion ticket bucket"
                  labelFormatter={b => `${b.event.name} – ${b.name}`}
                  eventBucketId={this.props.bucket.event_bucket}
                  onChange={selected =>
                    this.onChangeValue("autoissue_companion_ticket", selected)
                  }
                />
              ) : null}
            </div>
          </div>
        </div>

        <div style={styles.actions}>
          {/* <RaisedButton
            label={this.state.dirty ? "Save" : "No changes to save"}
            primary={true}
            disabled={!this.state.dirty}
            onClick={this.save}
          /> */}
          <RaisedButton
            label="Remove"
            onClick={this.delete}
            style={{ marginLeft: 7 }}
          />
          <RaisedButton
            label="▲"
            style={{ minWidth: 30, marginLeft: 7 }}
            disabled={!this.props.canShiftUp}
            onTouchTap={() => this.props.shiftPosition(-1)}
          />
          <RaisedButton
            label="▼"
            style={{ minWidth: 30, marginLeft: 7 }}
            disabled={!this.props.canShiftDown}
            onTouchTap={() => this.props.shiftPosition(1)}
          />
        </div>
      </div>
    );
  }
}

export default TicketBucketEditor;



// WEBPACK FOOTER //
// ./src/app/components/partials/ticket-bucket-editor.jsx